import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 admin-body" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6">
          <div className="w-12 h-12 rounded-full bg-[var(--accent)] text-white flex items-center justify-center">
            <Lock size={20} />
          </div>
        </div>
        <h1 className="font-display text-4xl text-center mb-2">Studio Login</h1>
        <p className="text-center text-[var(--text-secondary)] mb-10 text-sm">
          Enter your credentials to edit your site.
        </p>
        <form onSubmit={onSubmit} className="space-y-4 admin-card p-8">
          <div>
            <label className="label-eyebrow block mb-2">Email</label>
            <input
              type="email"
              required
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="label-eyebrow block mb-2">Password</label>
            <input
              type="password"
              required
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              autoComplete="current-password"
            />
          </div>
          {err && <p className="text-sm text-red-700" data-testid="login-error">{err}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <p className="text-center text-xs text-[var(--text-secondary)] mt-6">
          ← <a href="/" className="hover:text-[var(--accent)]">Back to site</a>
        </p>
      </div>
    </div>
  );
}
